var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-detail",attrs:{"id":"content-detail"}},[_vm._t("default"),_c('form-button',{attrs:{"text":_vm.$t('Components.ContentDetail.BACK'),"type":'outline'},on:{"click":_vm.back}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }